import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Chip,
  IconButton,
  Typography,
  // Typography,
} from "@mui/material";
import { alpha } from "@mui/material/styles";

import AddIcon from "@mui/icons-material/Add";
import LinearProgressTodo from "./LinearProgressTodo";
import TableTodoCustom from "./TableTodoCustom";
// import StringAvatar from "../common/StringAvatar";
import { useTranslation } from "react-i18next";
// import { shallowEqual, useSelector } from "react-redux";
// import TaskIcon from "@mui/icons-material/Task";
import AddTodoModal from "./AddTodoModal";
import useOpen from "../../hooks/useOpen";

const TodoListProfile = ({
  person,
  context,
  owner,
  sx,
  setOwnerModal,
  setOpenDetailModal,
  setTodoDetail,
  group,
  progress = { finished: 0, total: 0 },
}: any) => {
  const isOwner = context === owner;
  const tasks = group?.tasks ?? [];

  const finishedTasks =
    tasks?.length > 0
      ? tasks.filter((el: any) => el.finished)?.length
      : progress?.finished;
  const totalTasks = tasks.length > 0 ? tasks.length : progress?.total;
  const isFinished = totalTasks === finishedTasks;

  const { open, isOpen, close } = useOpen();

  return (
    <div>
      <Card sx={{ position: "relative", width: "100%", ...sx }}>
        <Header
          owner={owner}
          person={person}
          setOpenAddTodoModal={open}
          setOwnerModal={setOwnerModal}
          title={group?.label}
          status={isFinished ? "finished" : "ongoing"}
          canCreate={group?.canCreate}
        />
        <CardContent
          sx={{ paddingInline: "16px", paddingBottom: "2px !important" }}
        >
          <LinearProgressTodo
            progress={{
              current: finishedTasks,
              total: totalTasks,
            }}
          />
          {/* <Typography
            sx={{ color: (theme) => theme.palette.warning.main }}
            fontSize={8}
            fontWeight={800}
            textTransform="uppercase"
          >
            1 {t("todo.comment_pending")}
          </Typography> */}
          <TableTodoCustom
            isOwner={isOwner}
            tasks={group?.tasks ?? []}
            setOpenDetailModal={setOpenDetailModal}
            setTodoDetail={setTodoDetail}
            setOwnerModal={setOwnerModal}
            owner={owner}
          />
        </CardContent>
      </Card>

      <AddTodoModal open={isOpen} close={close} group={group} />
    </div>
  );
};

export default TodoListProfile;

// const Logo: React.FC<any> = ({ owner, person }) => {
//   const tokenData = useSelector((state: any) => state.user, shallowEqual);

//   return (
//     <Box paddingRight={1}>
//       {owner === "benef" ? (
//         <StringAvatar
//           profile
//           size={40}
//           name={person?.fullName}
//           sx={{
//             borderRadius: "8px",
//           }}
//         />
//       ) : owner === "company" ? (
//         <Box
//           display="flex"
//           justifyContent="center"
//           alignItems="center"
//           sx={{
//             borderRadius: "8px",
//             width: 40,
//             height: 40,
//             minWidth: 40,
//             minHeight: 40,
//             backgroundColor: "#f0f0f0",
//           }}
//         >
//           <img
//             src={tokenData.company_logo ?? "/static/icons/portfolio.svg"}
//             width="40px"
//             alt="logo entreprise"
//           />
//         </Box>
//       ) : (
//         <Box
//           display="flex"
//           justifyContent="center"
//           alignItems="center"
//           sx={{
//             borderRadius: "8px",
//             width: 40,
//             height: 40,
//             minWidth: 40,
//             minHeight: 40,
//             backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.1),
//           }}
//         >
//           <TaskIcon color="primary" />
//         </Box>
//       )}
//     </Box>
//   );
// };

const Header: React.FC<any> = ({
  owner,
  person,
  setOpenAddTodoModal,
  setOwnerModal,
  title,
  status,
  canCreate,
}) => {
  return (
    <CardHeader
      sx={{ pt: 2 }}
      title={
        <Box>
          <Box display="flex" alignItems="center" position="relative">
            {/* <Logo owner={owner} person={person} /> */}

            <Title owner={owner} title={title} />

            {canCreate && (
              <Box
                sx={{
                  position: "absolute",
                  top: -10,
                  right: -20,
                }}
              >
                <IconButton
                  onClick={() => {
                    setOpenAddTodoModal(true);
                    setOwnerModal(owner);
                  }}
                >
                  <AddIcon />
                </IconButton>
              </Box>
            )}
          </Box>

          <Status status={status} />
        </Box>
      }
    />
  );
};

const Title: React.FC<any> = ({ owner, title }) => {
  // const { t } = useTranslation("common");
  // const context = useSelector((state: any) => state.auth.context);
  return (
    <Box>
      <Box display="flex" alignItems="center">
        <Typography variant="subtitle2">{title}</Typography>
        {/* <Typography
          color="error"
          fontSize={8}
          fontWeight={800}
          paddingLeft={1}
          textTransform="uppercase"
        >
          {t("todo.important")}
        </Typography> */}
      </Box>

      {/* <Typography variant="body2" sx={{ opacity: "0.7" }}>
        {owner === "company"
          ? `${t("todo.subtitle_company")}`
          : owner === "benef"
          ? `${t("todo.subtitle_" + owner + "_" + context)}`
          : `${t("todo.subtitle_advisor_benef")}`}
      </Typography> */}
    </Box>
  );
};

const Status: React.FC<any> = ({ status }) => {
  const { t } = useTranslation("common");
  return (
    <Box display="flex" marginTop={1}>
      <Chip
        label={t(`todo.status.${status}`)}
        sx={{
          fontSize: "0.75rem",
          fontWeight: "normal",
          color: "primary.main",
          backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.1),
          height: "24px",
          borderRadius: "5px",
        }}
      />
      {/* <Chip
        label={`${t("todo.limit_date")} : 24 juin 2025 `}
        sx={{
          fontSize: "0.75rem",
          fontWeight: "normal",
          color: (theme) => theme.palette.warning.main,
          backgroundColor: "rgba(255, 165, 0, 0.1)",
          height: "24px",
          marginLeft: "8px",
          borderRadius: "5px",
        }}
      /> */}
    </Box>
  );
};
